import { useTranslation } from "react-i18next"
import ModalService from "src/modals"

import { units } from "src/assets/images"

import "./UnitItem.css"

const UnitItem = ({ type, count, showLabel = false }) => {
  const { t } = useTranslation()
  const img = units[type]
  return (
    <div
      className="unit-bg-chip pressable"
      key={type}
      role="button"
      tabIndex={0}
      style={{
        backgroundImage: `url(${img})`,
      }}
      onClick={(e) => {
        // Chips sit inside clickable cards (a movement card opens its city); the unit sheet must
        // not also fire the card underneath.
        e.stopPropagation()
        ModalService.show("UnitModal", { unitType: type })
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.stopPropagation()
          ModalService.show("UnitModal", { unitType: type })
        }
      }}
    >
      {/* The garrison reads as a list of kinds, not a row of faces — the name carries as much as
          the portrait once a city holds four of them. */}
      {showLabel ? <span className="unit-bg-label">{t(`city.units.${type}`, { defaultValue: type })}</span> : null}
      <span className="unit-bg-count">{count}</span>
    </div>
  )
}

export default UnitItem
